import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";

// FreshnessLabel — a small, muted, read-only data-freshness indicator: a clock
// icon + text. Deliberately not a control (no border, no hover, non-selectable)
// so it doesn't read like the interactive dropdowns next to it. Shared by the
// cost analyzer ("Data through …") and the AI usage monitor ("Updated … UTC").
export default function FreshnessLabel({ children, className = "" }) {
  return (
    <span className={`flex items-center gap-1.5 whitespace-nowrap text-[11px] text-text-3 select-none ${className}`}>
      <FontAwesomeIcon icon={icon({ name: "clock", family: "sharp", style: "light" })} className="text-[10px]" />
      {children}
    </span>
  );
}

FreshnessLabel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
